// Central brand-config module per FR-041. All product-name strings used in
// user-facing surfaces (page titles, header logo, PDF labels, etc.) flow
// from here. Server-side brand strings live in env vars (PRODUCT_NAME,
// PRODUCT_TAGLINE, COMPANY_NAME, PRODUCT_LEGAL_NAME) consumed by
// server/internal/pdf and server/internal/version per T124.

export const productName = 'LooporaData';
export const productTagline = 'Quantify the value of your healthcare data';
export const companyName = 'LooporaData';
export const productLegalName = 'LooporaData (working name)';

// Brand wordmark — the PNG carries both the symbol and "LooporaData"
// type, so chrome that uses logoSrc does NOT render productName next to
// it. Sourced from ~/code/brand/assets/logos and copied into public/.
export const logoSrc = '/ld-logo.png';
export const logoSrcOnDark = '/ld-logo-white.png';

// Flex parents default to align-items: stretch, which distorts <img> width.
export const logoStyleChrome = {
  height: '48px',
  width: 'auto',
  maxWidth: '220px',
  display: 'block',
  alignSelf: 'flex-start',
  objectFit: 'contain',
};

export const logoStyleCompact = {
  height: '32px',
  width: 'auto',
  maxWidth: '180px',
  display: 'block',
  alignSelf: 'flex-start',
  objectFit: 'contain',
};

// Website terms (GCS-29) — marketing site; versioned row in app.legal_documents.website_terms TBD.
export const websiteTermsUrl = 'https://www.looporadata.ai/terms';
export const platformTermsUrl = websiteTermsUrl;
export const privacyUrl = 'https://www.looporadata.ai/privacy';

// In-app Calculator Terms of Use (GCS-65) — HTML at this path, not a PDF.
export const calculatorTermsPath = '/terms';

/** @deprecated use platformTermsUrl for main site; calculatorTermsPath for HC-17 checkbox */
export const termsUrl = calculatorTermsPath;

// Share-link origin — typically matches the deployed hostname.
// On localhost dev, share links use window.location.origin at generation time.
export const shareLinkOrigin = typeof window !== 'undefined' ? window.location.origin : '';

const brand = {
  productName,
  productTagline,
  companyName,
  productLegalName,
  logoSrc,
  logoSrcOnDark,
  platformTermsUrl,
  websiteTermsUrl,
  calculatorTermsPath,
  termsUrl,
  privacyUrl,
  shareLinkOrigin,
};

export default brand;
